import { Dropdown } from "@similarweb/ui-components";
import { useDispatch } from "react-redux";
import "app/components/React/UserSettingDropdown/UserSettingsDropdown.scss";
import type { FC } from "react";
import { useEffect } from "react";
import { toggleSolutionUsers } from "app/actions/userData/primarySidebar3Actions";
import { SolutionItem } from "@similarweb/ui-components";
import type { IAvailableSolutionsNewSidebar } from "app/components/sidebar3/primary-side-bar/secondary-actions/Solutions/SolutionsSwitcherMenuComponent";
import { UserSettingsWrapper } from "app/components/sidebar3/primary-side-bar/secondary-actions/Solutions/SolutionItemDropdown.styles";
import { AccountSwitcher } from "app/components/sidebar3/primary-side-bar/secondary-actions/Solutions/AccountSwitcher";

interface ISolutionItemDropdown {
    title?: string;
    text: string;
    itemKey?: string;
    urlOrHandler?: string | (() => void);
    linkTarget?: "_self" | "_blank";
    onClick?: () => void;
    isSelected?: boolean;
    dropdownRef?: React.RefObject<any>;
    key: string;
    sol: IAvailableSolutionsNewSidebar;
}

export const SolutionItemDropdown: FC<ISolutionItemDropdown> = ({ sol, title, text, onClick, dropdownRef, key }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(toggleSolutionUsers(false));
    }, []);

    return (
        <Dropdown
            ref={dropdownRef}
            width={211}
            dropdownPopupHeight={window.outerHeight <= 768 ? 500 : 714}
            buttonWidth={"auto"}
            appendTo={"body"}
            dropdownPopupPlacement="ontop-right"
            closeOnItemClick={false}
            cssClassContainer={"DropdownContent-container AccountSwitcher"}
            onToggle={(isOpen) => dispatch(toggleSolutionUsers(isOpen))}
        >
            {[
                <UserSettingsWrapper key={`${title}-wrapper`}>
                    <SolutionItem
                        {...sol}
                        key={key}
                        title={title}
                        text={text}
                        onClick={onClick}
                    ></SolutionItem>
                </UserSettingsWrapper>,
                <AccountSwitcher sol={sol} />,
            ]}
        </Dropdown>
    );
};
